module.exports = "/assets/6803cfb9f2f8ff5b3071a46bfc7c0d21.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/AM.png
// module id = 2329
// module chunks = 0